import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';

import LearningModuleCategoryList from '../components/LearningModuleCategoryList';
import { loadModuleCategories } from '../../../../../state/modules/learnings/actions';

const defaultLimit = 20;
const defaultOrder = 'name';

const mapStateToProps = (state, ownProps) => {
  // merge results for all module categories

  const activeId = state.careGuides.get('activeId');
  const careGuide = activeId
    ? denormalize(
        state.entities.getIn(['careGuides', activeId]),
        schema.careGuide,
        state.entities.toJS()
      )
    : null;

  const partnershipId = careGuide ? careGuide?.partnership.id : null;

  const results = [].concat.apply(
    [],
    Object.entries(
      state.learnings.getIn(
        [
          'moduleCategories',
          activeId,
          partnershipId,
          'pages',
          defaultOrder,
          defaultLimit,
        ],
        {}
      )
    ).map(([k, v]) => v.toArray())
  );
  const list =
    results.length > 0
      ? results.map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['learningModuleCategories', x]),
              schema.learningModuleCategory,
              state.entities.toJS()
            ),
          };
        })
      : [];

  return {
    list,
    activeId,
    partnershipId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (
      careGuideId,
      partnershipId,
      page = 1,
      limit = defaultLimit,
      order = defaultOrder,
      cb = function () {}
    ) => {
      dispatch(
        loadModuleCategories(
          careGuideId,
          partnershipId,
          page,
          limit,
          order,
          (success, total) => {
            if (success) {
              // loop over all pages to get all modules
              const pageCount = Math.ceil(total / limit);
              for (var i = 2; i <= pageCount; i++) {
                dispatch(
                  loadModuleCategories(
                    careGuideId,
                    partnershipId,
                    i,
                    limit,
                    order
                  )
                );
              }
              cb();
            }
          }
        )
      );
    },
  };
};

const LearningModuleCategoryListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningModuleCategoryList);

export default LearningModuleCategoryListContainer;
